import type { TokensDto } from '../commonTypes/user.types';
import { diContainer } from '../libs/container';

export const ID_TOKEN: string = 'id_token';
export const ACCESS_TOKEN: string = 'access_token';
export const REFRESH_TOKEN: string = 'refresh_token';
export const EXPIRES_IN: string = 'expires_in';
export const TOKEN_TYPE: string = 'token_type';
export const BEARER: string = 'Bearer';
export const DEFAULT_TRACKING_TAB = 'default_tracking_tab';
export const CODE = 'code';
export const ERROR = 'error';
export const STATE = 'state';
export const CODE_VERIFIER = 'codeVerifier';
export const NONCE = 'nonce';
export const LANGUAGE = 'language';
export const NAVIGATION_SECTION_STATES = 'navigation_section_states';
export const NAVIGATION_DROPDOWN_STATES = 'navigation_dropdown_states';
export const FEATURE_FLAGS_CACHE = 'feature_flags_cache';

export class LocalStorage {
    public get(key: string): string | null {
        return localStorage.getItem(key);
    }

    public set(key: string, value: any): void {
        let to_add: string = '';
        if (typeof value === 'object') {
            to_add = JSON.stringify(value);
        } else {
            to_add = value.toString();
        }
        localStorage.setItem(key, to_add);
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    public removeAuth(): void {
        localStorage.removeItem(FEATURE_FLAGS_CACHE);
        localStorage.removeItem(ID_TOKEN);
        localStorage.removeItem(ACCESS_TOKEN);
        localStorage.removeItem(EXPIRES_IN);
        localStorage.removeItem(REFRESH_TOKEN);
        localStorage.removeItem(TOKEN_TYPE);
        localStorage.removeItem(NAVIGATION_DROPDOWN_STATES);
    }

    public setAuth(tokens: TokensDto): void {
        this.set(ID_TOKEN, tokens.idToken);
        this.set(ACCESS_TOKEN, tokens.accessToken);
        this.set(EXPIRES_IN, tokens.refreshToken);
        this.set(REFRESH_TOKEN, tokens.refreshToken);
    }
}

diContainer.bindAsConstant(LocalStorage, new LocalStorage());
